<template>
  <div
    :class="{ 'phone-input': true,'error--text': error,'phone-input--outlined': outlined }"
  >
    <div>
      <MazPhoneNumberInput
        ref="phoneInput"
        v-model="phoneNumber"
        default-country-code="US"
        no-example
        :error="error"
        @update="update"
        :class="{'phone-input-auto-width': !showIcon}"
      />
      <v-icon v-if="showIcon" icon="phone" style="margin-left: 0.9rem; margin-top: 0.7rem; color: grey;"></v-icon>
    </div>
    <div class="v-text-field__d etails">
      <div class="v-messages theme--light">
        <div class="v-messages__wrapper error--text">
          {{ errorMessages }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import { showReportDialog } from '@sentry/vue';


@Component({
  components: { MazPhoneNumberInput }
})
export default class RegisterForm extends Vue {
  @Prop({ type: Array }) rules!: Function[];
  @Prop({ type: Boolean }) outlined!: boolean[];
  @Prop({ type: Boolean, default: true }) showIcon: boolean;
  error: boolean = false
  errorMessages: string = ''
  wasEdited: boolean = false
  phoneNumber: string = ''

  getFullValue () {
    // @ts-ignore
    return this.phoneNumber
  }

  update (val) {
    if (!this.wasEdited) {
      this.wasEdited = true
      return
    }
    if (!this.rules || !this.rules.length) {
      return
    }
    const errors = this.rules
      .map(rule => rule(val.formatInternational || val.phoneNumber))
      .concat(val.isValid ? true : 'Incorrect phone number')
    this.errorMessages = errors.filter(error => typeof error === 'string').join(' ')
    this.error = !!this.errorMessages.length
  }
}
</script>

<style lang="scss">
.phone-input {
  .m-phone-number-input .m-input-wrapper {
    border-radius: 4px  !important;
    border-color: rgba(0, 0, 0, 0.42);
  }
  .m-input-wrapper-input {
    width: 20rem;
  }
  .error--text {
    color: red;
  }
}
.phone-input-auto-width {
  .m-input-wrapper-input {
    width: auto;
  }
}
</style>
